export const GOT_ERROR = 'REQQ_LITE/v1/got_error';
export const POST = 'REQQ_LITE/v1/post';
export const GOT_POST = 'REQQ_LITE/v1/got_post';
export const PUT = 'REQQ_LITE/v1/put';
export const GOT_PUT = 'REQQ_LITE/v1/got_put';
export const PATCH = 'REQQ_LITE/v1/patch';
export const GOT_PATCH = 'REQQ_LITE/v1/got_patch';
export const REMOVE = 'REQQ_LITE/v1/remove';
export const GOT_REMOVE = 'REQQ_LITE/v1/got_remove';
export const GET_SET = 'REQQ_LITE/v1/get_set';
export const GOT_SET = 'REQQ_LITE/v1/got_set';
export const RESET = 'REQQ_LITE/v1/reset';
